module.exports = __webpack_public_path__ + "static/img/bjh.04e50d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/bjh.png
// module id = cXW1
// module chunks = 0